/**
 *
 *  Header NavMenu
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 2025/04/09.
 *  Copyright (c) 2025-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useCallback, useState } from "react";
// import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";

// import { useAppState } from "../../../state";

// Components
import Dropdown from "../../Dropdown/Dropdown";

// Hooks
import useTheme from "../../ThemeProvider/useTheme/useTheme";

// Icons
// import CaretDownIcon from "../../../icons/CaretDownIcon";

// Utils
import { clientWidth } from "../../../utils";

export const NavMenuLink = ({
  className,
  to,
  title,
  icon,
  isNight,
  onClick,
}) => {
  return (
    <Link
      className={`${className} tbk-flex tbk-items-center tbk-pt-2 tbk-pb-1.5`}
      to={to}
      onClick={onClick}
    >
      <h4
        className={`tbk-text-main tbk-m-0 tbk-flex tbk-grow tbk-whitespace-nowrap`}
      >
        {title}
      </h4>
    </Link>
  );
};

export const NavMenu = ({
  children,
  title,
  isNight,
  buttonElement: ButtonElement,
  buttonElementProps,
  bgClass = "tbk-bg-basic-white",
  bgInverseClass = "tbk-backdrop-blur-xl",
  onNavMenuOpen,
  onNavMenuClose,
}) => {
  const location = useLocation();
  const { theme } = useTheme();

  const [isDropdownOpen, setIsDropdownOpen] = useState(); // eslint-disable-line
  const [bkgClass, setBkgClass] = useState();

  const handleNavMenuOpen = useCallback(() => {
    setIsDropdownOpen(true);
    onNavMenuOpen && onNavMenuOpen();
  }, []);

  const handleNavMenuClose = useCallback(() => {
    setIsDropdownOpen(false);
    onNavMenuClose && onNavMenuClose();
  }, []);

  React.useLayoutEffect(() => {
    setBkgClass(isNight ? bgInverseClass : bgClass);
  }, [isNight]);

  return (
    <div className="tb-header-menu-item tbk-text-main tbk-hidden md:tbk-block">
      <div className="">
        <Dropdown
          className="tb-dropdown-login"
          // active={isDropdownOpen}
          keepOpen={false}
          openOnHover
          buttonElement={ButtonElement}
          buttonElementProps={{
            isActive: isDropdownOpen,
            ...buttonElementProps,
          }}
          position={
            clientWidth() < theme.responsive.breakpoints.sm
              ? "fixed"
              : "absolute"
          }
          placement={
            clientWidth() < theme.responsive.breakpoints.sm
              ? "tbk-top-7 tbk-left-0 tbk-right-0"
              : "tbk-pt-[3px] tbk-left-0 tbk-right-0"
          }
          noBorder
          rounded={"bottom"}
          onOpen={handleNavMenuOpen}
          onClose={handleNavMenuClose}
        >
          <div
            className={`${
              isDropdownOpen ? "tbk-border-coral" : "tbk-border-transparent"
            } tbk-w-full ${bkgClass} tbk-z-995 tbk-will-change-background`}
          >
            {children}
          </div>
        </Dropdown>
      </div>
    </div>
  );
};

NavMenu.displayName = "NavMenu";

export default NavMenu;
